import { UpdateWorkRequirementScreeningBodyType } from "@libs/api/patients";
import { HTTPStatusCode } from "@libs/api/types";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

type WorkRequirementMemberParamsType = {
  workRequirementId: string;
  householdMemberId: string;
};

export const WorkRequirementsApi = {
  listWorkRequirements: async () => {
    const res = await tsRestClient().workRequirements.listWorkRequirements();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message:
        "Unexpected response in WorkRequirementsApi.listWorkRequirements",
      shouldThrowError: true,
    });
  },
  getWorkRequirement: async (workRequirementId: string) => {
    const res = await tsRestClient().workRequirements.getWorkRequirement({
      params: { workRequirementId },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Unexpected response in WorkRequirementsApi.getWorkRequirement",
      shouldThrowError: true,
    });
  },
  updateWorkRequirementScreening: async ({
    workRequirementId,
    screening,
  }: {
    workRequirementId: string;
    screening: UpdateWorkRequirementScreeningBodyType;
  }) => {
    const res =
      await tsRestClient().workRequirements.updateWorkRequirementScreening({
        params: { workRequirementId },
        body: screening,
      });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message:
        "Unexpected response in WorkRequirementsApi.updateWorkRequirementScreening",
      shouldThrowError: true,
    });
  },
  addWorkRequirementDocument: async ({
    workRequirementId,
    householdMemberId,
    householdMemberDocumentId,
    coverageMonth,
  }: WorkRequirementMemberParamsType & {
    householdMemberDocumentId: string;
    coverageMonth: string | null;
  }) => {
    const res =
      await tsRestClient().workRequirements.addWorkRequirementDocument({
        params: { workRequirementId, householdMemberId },
        body: { householdMemberDocumentId, coverageMonth },
      });

    if (res.status === HTTPStatusCode.CREATED) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message:
        "Unexpected response in WorkRequirementsApi.addWorkRequirementDocument",
      shouldThrowError: true,
    });
  },
  trackVolunteerOfframpClick: async (
    params: WorkRequirementMemberParamsType,
  ) => {
    const res =
      await tsRestClient().workRequirements.trackVolunteerOfframpClick({
        params,
      });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message:
        "Unexpected response in WorkRequirementsApi.trackVolunteerOfframpClick",
    });
  },
};
